<template>
    <div>
        <v-row>
            <v-col cols="11">
                <h1>{{my_ui.title}}</h1>
            </v-col>
            <v-col cols="1">
                <v-btn
                    icon
                    @click="$emit('refresh')"
                    color="primary"
                >
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <!-- <v-row v-for="filt in my_ui.filtrables">
            <v-col cols="2">
                <v-text-field
                    v-model="filters[filt]"
                    :label="filt"
                    :append-icon="filters[filt] ? 'mdi-close' : 'mdi-magnify'"
                    :append-icon-cb="() => filters[filt] = ''"
                    @keyup.enter="refreshList"
                ></v-text-field>
            </v-col> 
        </v-row> -->
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            @click:row="rowClick"
            :loading="loading"
        >
        </v-data-table> 
    </div>
</template>
    
<script>
import GenericTableEditableComponent from '@/components/GenericTableEditableComponent.vue'
import RecursivePayloadOnSchemaEditor from '@/modules/entities/infra/RecursivePayloadOnSchemaEditor.vue'
import { EntityInstanceApiRepository, EntityTypeApiRepository } from '@/modules/entities/infra/EntitiesApiRepositories'
export default {
    name: "ListViewerV0",
    components: {
    RecursivePayloadOnSchemaEditor,
    GenericTableEditableComponent
    },
    data() {
    return {
        items: [],
        headers: [],
        filters: {},
    }
    },
    props: {
    list_of_instances: {
        type: Array,
        required: true,
    },
    my_ui: {
        type: Object,
        required: true,
        default: {},
    },
    loading: {
        type: Boolean,
        default: false,
    },
    },
    async mounted() {
    this.items = this.get_items(this.list_of_instances);
    this.headers = this.get_flat_headers(this.my_ui.headers);
    },
    methods: {
        get_list_repr(item,i){
            let res = {'uuid': item.uuid , 'my_indx':i}
            for(let header of this.my_ui.headers){
                let key = header.value;
                let keys = key.split('.');
                let value = item;
                for(let k of keys){
                    value = value[k];
                    if (value === undefined){
                        break;
                    }
                }
                res[key] = value;
            }
            return res;
        },
        get_items(instances){
            return instances.map((item, index) => this.get_list_repr(item, index));
        },
        get_flat_headers(headers){
            return headers;
        },
        rowClick(row) {
            this.$emit('row-click', this.list_of_instances[row.my_indx]);
        },
    },
    
    
};
</script>

<style scoped>
.nested-section {
    padding-left: 10px;
    /*border-left: 1px solid #ccc; */
    margin-top: 10px;
}
</style>
    